module.exports = __webpack_public_path__ + "static/media/x.bed8223c.png";